import { FC } from 'react';

import { Element } from 'react-scroll';

import { x } from '@ui-furniture/style';

export const EndOfMessages: FC<{
  id: string;
}> = ({ id }) => (
  <x.div marginTop='40px'>
    <Element name={id} />
  </x.div>
);
